import React from 'react'
import "./Thanku.css";
function Thanku() {
    return (
        <div className="thanku">
            <h2>Thank You for shopping with us!</h2>
               <h2> We hope to see you back...</h2>
            
        </div>
    )
}

export default Thanku
